import Image from '../Image/Image';
import { getProjectType, ProjectTypes } from '@r-and-a-shared-ui/utils';

import stylesPP from './scss/SectionTitlePP.module.scss';
import stylesMMB from './scss/SectionTitleMMB.module.scss';

export interface SectionTitleProps {
  title?: string;
  backgroundImage?: string;
  kontentItemId?: string;
}

export function SectionTitle(props: SectionTitleProps) {
  const { title, backgroundImage, kontentItemId } = props;

  const projectType = getProjectType();
  const isPPproject = projectType === ProjectTypes.PlayerPortals;
  const styles = isPPproject ? stylesPP : stylesMMB;

  return (
    <div className={styles.wrapper} data-kontent-item-id={kontentItemId}>
      <div className={styles.container}>
        <div className={styles.content}>
          {backgroundImage && (
            <div className={styles.background}>
              <Image
                imageUrl={backgroundImage}
                alt={title || 'SectionTitle'}
                width={0}
                height={0}
              />
            </div>
          )}
          {title && (
            <div className={styles.title}>
              <h1>{title}</h1>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default SectionTitle;
